import { Instagram, Linkedin, Twitter, Mail } from "lucide-react";

const cols = [
  {
    title: "Product",
    links: [
      ["How it works", "#how"],
      ["Plans", "#plans"],
      ["Partners", "#partners"],
      ["FAQs", "#faqs"],
    ],
  },
  {
    title: "Company",
    links: [
      ["About", "#"],
      ["Careers", "#"],
      ["Press", "#"],
      ["Contact", "#waitlist"],
    ],
  },
  {
    title: "Partners",
    links: [
      ["Become a Zypper", "#partners"],
      ["Apartment Societies", "#partners"],
      ["Insurance partners", "#"],
      ["Brand partners", "#"],
    ],
  },
  {
    title: "Legal",
    links: [
      ["Privacy", "#"],
      ["Terms", "#"],
      ["DPDP 2023", "#"],
      ["Refund policy", "#"],
    ],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative border-t border-white/5 px-6 md:px-12 pt-20 pb-10 bg-black"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8 md:gap-12 mb-16">
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-5">
              <span className="h-8 w-8 rounded-lg bg-[#FF5A00] flex items-center justify-center font-heading font-bold text-white text-lg">
                Z
              </span>
              <span className="font-heading text-xl tracking-tight font-semibold">
                Zyp
              </span>
            </div>
            <p className="text-zinc-400 text-sm max-w-xs leading-relaxed">
              The operating system for car ownership. Premium, waterless, doorstep car care for apartment dwellers in Bangalore.
            </p>
            <div className="flex items-center gap-3 mt-6">
              {[
                { Icon: Instagram, label: "instagram" },
                { Icon: Twitter, label: "twitter" },
                { Icon: Linkedin, label: "linkedin" },
                { Icon: Mail, label: "email" },
              ].map(({ Icon, label }) => (
                <a
                  key={label}
                  href="#"
                  data-testid={`footer-social-${label}`}
                  className="h-9 w-9 rounded-full border border-white/10 flex items-center justify-center text-zinc-400 hover:text-white hover:border-white/30 transition-all"
                >
                  <Icon size={15} />
                </a>
              ))}
            </div>
          </div>

          {cols.map((col) => (
            <div key={col.title}>
              <div className="text-xs uppercase tracking-[0.22em] text-zinc-500 mb-4">
                {col.title}
              </div>
              <ul className="space-y-3">
                {col.links.map(([label, href]) => (
                  <li key={label}>
                    <a
                      href={href}
                      data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                      className="text-sm text-zinc-300 hover:text-white transition-colors"
                    >
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Massive logotype */}
        <div className="relative">
          <div
            aria-hidden
            className="font-heading font-semibold tracking-tighter text-[20vw] leading-[0.9] text-transparent bg-clip-text bg-gradient-to-b from-white/5 to-transparent select-none"
          >
            Zyp.
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mt-10 pt-6 border-t border-white/5">
          <p className="text-xs text-zinc-500">
            © {new Date().getFullYear()} Zyp Mobility Pvt Ltd. Built in Bangalore.
          </p>
          <p className="text-xs text-zinc-500">
            Made with obsession for clean cars.
          </p>
        </div>
      </div>
    </footer>
  );
}
